<template>
  <div class="rank">
    <div class="rank-wrap">
      <img
        :src="OSS_BASE + '/market/img/rank/back.jpg'"
        class="rank-background"
      />
      <div class="rank-wrap-content">
        <!-- <div class="rank-top-card" v-if="loaded">
          <rank-item-top :item="rankData[1]" :index="2" />
          <rank-item-top :item="rankData[0]" :index="1" />
          <rank-item-top :item="rankData[2]" :index="3" />
        </div> -->
        <div class="rank-center" :class="ratio <= 0.5 ? 'narrow' : ''">
          <div class="rank-list-center">
            <div class="my-rank"  v-if="isCn == 1">
              <div class="my-rank-left">
                我是<span class="my-rank-data">{{
                  $store.state.userDetail.nickname ||
                  $store.state.userDetail.username ||
                  ""
                }}</span><br />
                <template v-if="costTime>0&&rank>0">游戏用时<span class="my-rank-data">{{ costTime }}s</span><br />排名<span class="my-rank-data">{{ rank }}</span></template>
                <template v-else>
                  正在解救<span class="my-rank-data">GIFT GUY</span>
                </template>
              </div>
              <div class="game-code">
                <img :src="OSS_BASE + '/market/img/code.png'" />
                <p>扫码玩游戏</p>
              </div>
            </div>
            <div class="rank-list-row title">
              <div class="rank-list-column-1">Ranking</div>
              <div class="rank-list-column-2">ID</div>
              <div class="rank-list-column-3">Time</div>
            </div>
            <template v-if="loaded">
              <!-- <rank-item
                :item="rankData[0]"
                :index="1"
                :rank="rank"
                v-if="rankData[0]"
              />
              <rank-item
                :item="rankData[1]"
                :index="2"
                :rank="rank"
                v-if="rankData[1]"
              />
              <rank-item
                :item="rankData[2]"
                :index="3"
                :rank="rank"
                v-if="rankData[2]"
              /> -->
              <rank-item
                :item="rankData[i - 1]"
                :index="i"
                :rank="rank"
                v-for="i in 5"
                :key="i"
              />
            </template>
            <div class="rank-list-row current" v-if="rank > 5&& isCn != 1">
              <div class="rank-list-column-1">
                <span class="rank-index">{{ rank }}</span>
              </div>
              <div class="rank-list-column-2">
                <template v-if="$store.state.userDetail">
                  {{
                    $store.state.userDetail.username ||
                    $store.state.userDetail.nickname
                  }}</template
                >
              </div>
              <div class="rank-list-column-3 times">{{ costTime }}s</div>
            </div>
            <!-- <div class="rank-list-row">
              <div class="rank-list-column-1">
                <img
                  :src="OSS_BASE + '/market/img/rank/02.png'"
                  class="rank-list-column-image"
                />
              </div>
              <div class="rank-list-column-2">
                user name user name user name
              </div>
              <div class="rank-list-column-3 times">25s</div>
            </div>
            <div class="rank-list-row">
              <div class="rank-list-column-1">
                <img
                  :src="OSS_BASE + '/market/img/rank/03.png'"
                  class="rank-list-column-image"
                />
              </div>
              <div class="rank-list-column-2">
                user name user name user name
              </div>
              <div class="rank-list-column-3 times">25s</div>
            </div>
            <div class="rank-list-row">
              <div class="rank-list-column-1">
                <span class="rank-index">4</span>
              </div>
              <div class="rank-list-column-2">
                user name user name user name
              </div>
              <div class="rank-list-column-3 times">25s</div>
            </div> -->
          </div>
          <div class="rule-wrap-cn" style="position: relative" v-if="isCn == 1">
            <!-- <div class="rule-wrap-left">
              <img :src="OSS_BASE + '/market/img/code.png'" />
              <p>扫码玩游戏</p>
            </div> -->
            <div class="rule-wrap-right">
              <!-- <div class="rule-title-cn">游戏规则：</div> -->
              <div class="rule-desc-cn">
                参与游戏的所有玩家：<br />
                <!-- 1、凡分享至朋友圈或10人以上为微信群组者，即可到活动现场领取六一礼物。<br />
                2、实时游戏排名第一者，分享排行榜至朋友圈集赞31个，添加微信号SANYIOHQ,即可瓜分现金红包；<br />
                3、最终游戏排名第一者（截止6月3日24：00），还可获得SY31儿童节限量纪念版T恤一件。 -->
                1、凡分享至朋友圈或10人以上为微信群组者，即可到活动现场领取六一礼物。<br />
                2、实时游戏排名前五者，分享排行榜至朋友圈集赞31个，添加微信号SANYIOHQ,参与瓜分现金红包；<br />
                3、最终游戏排名第一者（截止6月3日23：59），还可获得SY31儿童节限量纪念版T恤一件。<br />
              </div>
              <!-- <div style="text-align:center; margin-top:4px"><img :src="OSS_BASE + '/market/img/code.png'" style="width:30%;" />
              <p>扫码玩游戏</p></div> -->
            </div>
          </div>
          <div style="position: relative" v-else>
            <img :src="OSS_BASE + '/market/img/rank/rule0.png'" />
            <div class="rule-content">
              <div class="rule-title">Play Game and Win Amazon Gift Card</div>
              <div class="rule-desc">
                <p>
                  Forward the game to your FB page, get as many likes as you
                  can, then you may win a $20 Amazon gift card Play game and try
                  to be top 3 player on the ranking list, and win $20/30/50
                  Amazon gift card
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rank-top-nav">
        <span class="iconfont close" @click="hideRank">&#xe6e2;</span>
        <span>Ranking List</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getRankList, getMyRank } from "@/util/data.js";
import { showToast } from "@/util/utils.js";
import rankItemTop from "./rankItemTop.vue";
import rankItem from "./rankItem.vue";
export default {
  components: {
    rankItemTop,
    rankItem,
  },
  props: ["isCn"],
  data() {
    return {
      ratio,
      OSS_BASE,
      loaded: false,
      rankData: [],
      score: 0,
      costTime: 0,
      rank: 0,
    };
  },
  created() {
    this.handleGetRanks();
    this.handleGetMyRank();
    const infoString = window.localStorage.getItem("userDetail");
    // var info = infoString?JSON.parse(window.localStorage.getItem("userDetail")):this.$store.state.userDetail;
  },
  methods: {
    hideRank() {
      this.$emit("statusChanged", false);
    },
    handleGetRanks() {
      getRankList({ activity_id: this.$route.params.id })
        .then((res) => {
          this.loaded = true;
          if (res.code === 1 && res.data) {
            this.rankData = res.data.filter((item) => item.score > 20);
          } else {
            var msg = res.message || res.msg || "Fail!";
            showToast(this, msg);
          }
        })
        .catch((err) => {
          showToast(this, "Fail!");
        });
    },
    handleGetMyRank() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (token) {
        getMyRank(
          {
            activity_id: this.$route.params.id,
          },
          token
        )
          .then((res) => {
            if (res.code === 1) {
              if (res.data.score != -1) {
                this.score = res.data.score;
              }
              console.log(res.data);
              if (res.data.rank != -1) this.rank = res.data.rank;
              if (res.data.cost_time != -1 && res.data.cost_time > 20) {
                this.costTime = res.data.cost_time;
              }
            } else {
              var msg = res.message || res.msg || "Fail!";
              showToast(this, msg);
            }
          })
          .catch((err) => {
            //showToast(this, "Fail!");
          });
      }
    },
  },
};
</script>

<style scoped>
img {
  max-width: 100%;
}
.rank {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(2, 13, 43, 0.8);
  overflow: hidden;
  z-index: 2;
}
.rank-background {
  /* width: auto;
    height: 100%;
    display: block;
    max-width: 100%;
    max-height: 100%; */
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 0;
}
.rank-wrap {
  width: 100%;
  height: 100%;
  max-width: 414px;
  max-height: 896px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.rank-wrap-content {
  position: relative;
  z-index: 2;
  padding-top: 12%;
}
.rank-top-card {
  width: 64.9%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.rank-top-card-left,
.rank-top-card-right {
  padding-top: 22%;
  width: 30%;
}
.rank-top-card-center {
  width: 33.6%;
}
.rank-top-card-content {
  position: relative;
}
.rank-top-time {
  color: #ffd75b;
  position: absolute;
  left: 50%;
  top: 64%;
  transform: translate(-50%, 0);
  text-align: center;
  font-size: 15px;
}
.rank-top-card-center .rank-top-time {
  color: #dd5a00;
}
.rank-top-name {
  text-align: center;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 320px;
}

.rank-center {
  width: 75.6%;
  margin: 11% auto 0;
  font-size: 16px;
}
.my-rank {
  color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.my-rank-left{
  width: 60%;
  line-height: 1.6;
}
.my-rank-data{
  font-weight:bold;
  color: #ffd75b;
  font-size: 14px;
}
.rule-title {
  margin-bottom: 4px;
  font-size: 14px;
  color: #ffd75b;
  padding: 0 7%;
}
.rule-content {
  position: absolute;
  top: 0;
  left: 0;
  padding: 26% 0 5.9%;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}
.rule-desc {
  padding: 0 7% 5.9%;
  background: #312275;
  padding-bottom: 12px;
  border-radius: 0 0 4px 4px;
}
.rule-desc p {
  margin-top: 4px;
}
.rank-top-nav {
  z-index: 3;
  color: #fff;
  position: absolute;
  left: 7%;
  top: 4%;
  width: 86%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.rank-top-nav .iconfont {
  padding: 4px;
}
.rank-list-row {
  font-size: 14px;
  display: flex;
  color: #fff;
  background: #4d38a1;
  position: relative;
  z-index: 1;
}
.rank-list-row:first-child {
  border-radius: 4px 4px 0 0;
}
.rank-list-row:nth-child(2n) {
  background: #211158;
}
.rank-list-row.current {
  z-index: 2;
}
.rank-list-row.current::after {
  background: #6e57e5;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 105%;
  height: 100%;
  border-radius: 4px;
  z-index: -1;
}
.rank-list-column-1,
.rank-list-column-2,
.rank-list-column-3 {
  font-size: 14px;
  /* padding-left: 8px; */
  padding: 12px 0 12px 12px;
  box-sizing: border-box;
}
.rank-list-column-1 {
  width: 22.5%;
  min-width: 80px;
  text-align: center;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rank-index {
  color: #fff;
}
.rank-list-column-2 {
  width: 56.5%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.rank-list-column-3 {
  width: 21.1%;
}
.rank-list-column-3.times {
  color: #ffd75b;
}
.rank-list-column-image {
  width: 30%;
  display: block;
  margin: 0 auto;
}
.rule-wrap-cn {
  display: flex;
  justify-content: space-between;
  background: #322275;
  font-size: 10px;
  padding: 5%;
  color: #fff;
  border-radius: 0 0 4px 4px;
}
.rule-wrap-left, .game-code {
  width: 21.8%;
}
.rule-wrap-left img {
  border-radius: 4px;
}
.rule-wrap-right {
  width: 60.9%;
  flex-grow: 1;
  padding-left: 5%;
  /* padding-left: 0; */
}

@media screen and (max-width: 414px) {
  /* .rank-list-row {
    display: none;
  } */
  .rank-top-time {
    top: 63%;
  }
  .rank-top-card-center .rank-top-time {
    top: 64%;
  }
  /* .rank-list-row.current::after {
    display: none;
  } */
  .narrow .rank-list-row,
  .rank-list-row.title,
  .rank-list-row.current {
    display: flex;
  }
  .narrow .rank-list-row.current::after {
    display: block;
  }
  .rank-list-column-1,
  .rank-list-column-2,
  .rank-list-column-3 {
    font-size: 12px;
  }
  .rank-list-column-1 {
    padding: 8px;
  }
}
@media screen and (max-width: 413px) {
  .rank-wrap-content {
    padding-top: 9%;
  }
  .rank-center {
    width: 86%;
  }
  /* .rule-wrap-cn {
    padding: 4%;
  } */
  .rule-wrap-left {
    font-size: 10px;
    width: 23.8%;
  }
  .rank-top-time {
    /* top: 62%; */
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/maze/Rank.vue